/**
 * @generated SignedSource<<eea353c225d7b05859b0a85da3e3ea1d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchGraphResult_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultGraphDocument";
  readonly connectorType: string | null | undefined;
  readonly id: string;
  readonly integrationId: string | null | undefined;
  readonly providerId: string | null | undefined;
  readonly subtype: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphBranch_AtlassianSearchPage" | "searchGraphCalendar_AtlassianSearchPage" | "searchGraphComment_AtlassianSearchPage" | "searchGraphCommit_AtlassianSearchPage" | "searchGraphConfluenceDc_AtlassianSearchPage" | "searchGraphConversation_AtlassianSearchPage" | "searchGraphCustomerContact_AtlassianSearchPage" | "searchGraphCustomerOrg_AtlassianSearchPage" | "searchGraphDashboard_AtlassianSearchPage" | "searchGraphDataTable_AtlassianSearchPage" | "searchGraphDeal_AtlassianSearchPage" | "searchGraphDefault_AtlassianSearchPage" | "searchGraphDesign_AtlassianSearchPage" | "searchGraphDocument_AtlassianSearchPage" | "searchGraphJiraDc_AtlassianSearchPage" | "searchGraphMessage_AtlassianSearchPage" | "searchGraphPullRequest_AtlassianSearchPage" | "searchGraphRepository_AtlassianSearchPage" | "searchGraphVideo_AtlassianSearchPage" | "searchGraphWorkItem_AtlassianSearchPage">;
  readonly " $fragmentType": "searchGraphResult_AtlassianSearchPage";
};
export type searchGraphResult_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphResult_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphResult_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    }
  ],
  "kind": "Fragment",
  "name": "searchGraphResult_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "providerId"
    },
    {
      "kind": "ScalarField",
      "name": "connectorType"
    },
    {
      "kind": "ScalarField",
      "name": "integrationId"
    },
    {
      "kind": "ScalarField",
      "name": "subtype"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphBranch_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphCalendar_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphComment_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphCommit_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphConfluenceDc_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphConversation_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphCustomerOrg_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphDeal_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphDefault_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphDesign_AtlassianSearchPage"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeThirdPartyId",
          "variableName": "includeThirdPartyId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "searchGraphDocument_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphMessage_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphJiraDc_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphPullRequest_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphRepository_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphVideo_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphWorkItem_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphDashboard_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphDataTable_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchGraphCustomerContact_AtlassianSearchPage"
    }
  ],
  "type": "SearchResultGraphDocument"
};

(node as any).hash = "411380182e4a765bff79b96addae7abd";

export default node;
